import cn from "classnames";

import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, useMediaQuery } from "@mui/material";

import { ApiHotelItem } from "@/api/hotel";
import { HOTEL_IMG, tranfer_bank_to_hotel } from "@/constants/hotels";
import { BANK_IMG, BANK_TYPE2 } from "@/constants/programs";
import useThemeData from "@/hooks/useThemeData";

import style from "./style.module.scss";

interface SummaryOptionsProps {
  data: ApiHotelItem;
  onLoad: () => void;
}

function getBanksByHotelName(name: string) {
  const banks = [];
  for (const [key, value] of tranfer_bank_to_hotel.entries()) {
    if (value.includes(name)) {
      const bname = BANK_TYPE2.get(key);
      if (bname && BANK_IMG[bname]) {
        banks.push(BANK_IMG[bname]);
      }
    }
  }

  return banks;
}

const SummaryOptions = ({ data, onLoad }: SummaryOptionsProps) => {
  const isMediaMax900 = useMediaQuery("(max-width:900px)");
  const isMediaMin800 = useMediaQuery("(min-width:800px)");

  const theme = useThemeData();

  const options = getBanksByHotelName(data.brand);

  const maxOptions = isMediaMax900 && isMediaMin800 ? 3 : 5;
  const showOptions = options.length > maxOptions ? maxOptions - 1 : maxOptions;

  return (
    <Box
      className="inline-flex rounded-[6px] p-[8px] items-center"
      sx={{
        backgroundColor: theme.isDarkMode ? "rgba(255, 255, 255, 0.08)" : "#FAFAFA",
      }}
    >
      {options && options.length > 0 ? (
        <Box
          className={cn("flex flex-wrap rounded-[6px] pl-[6px] pb-[10px] justify-center")}
          sx={{
            writingMode: "vertical-lr",
            maxHeight: "86px",
            backgroundColor: theme.isDarkMode ? "rgba(255, 255, 255, 0.16)" : "#EEEEEE",
          }}
        >
          {options.slice(0, showOptions).map((ele, i) => {
            return (
              <div key={i} className="relative">
                <img src={ele} className={style.optionItem} onLoad={onLoad} />
              </div>
            );
          })}
        </Box>
      ) : null}

      {options && options.length > 0 ? (
        <ArrowForwardIcon
          className="ml-[4px] mr-[3px] !text-[10px]"
          sx={{ color: (theme) => theme.palette.text.secondary }}
        />
      ) : null}

      <img className="w-[80px]" src={HOTEL_IMG[data.brand]} onLoad={onLoad} />
    </Box>
  );
};

export default React.memo(SummaryOptions);
